import {
	addressAPI,
	demographicAPI,
	disclosuresAPI,
	eligibilityAPI,
	employmentAPI,
	errorAPI,
	identificationAPI,
	incomeAPI,
	paymentProtectionAPI,
	propertyTypeAPI,
	propertyStatusAPI,
	formInputAPI,
	coApplicantAPI,
	reviewAPI,
	documentVerificationAPI,
	configurationAPI,
    applicantAPI
} from '@/api';

import applicationStore from './application';

import { acceptDisclosure } from '@/api/disclosures';
import { getEnumFromConfigObject, getListValueFromConfigObject } from '@/utils';
import axios from '@/utils/axios';

import * as Sentry from '@sentry/vue';

export default {
	namespaced: true,
	state: {
		states: [{ stateAbbreviation: '' }],
		residenceHistoryRequiredInMonths: 0,
		disclosures: [],
		disclosureId: 0,
		eligibilityCounties: [],
		eligibilityOptions: [],
		ineligiblePageText: '',
		eligibilityPageHeader: '',
		eligibilityPageSuboptionLabel: '',
		ineligiblePageCardText: '',
		//occupations: [],
		employmentHistoryRequiredInMonths: 0,
		employmentStatuses: [],
		citizenshipStatuses: [],
		maritalStatuses: [],
		identificationTypes: [],
		countries: [],
		acceptedCountryCodes: [],
		incomeSources: [],
		declinePageContent: '',
		declineCardText: '',
		reviewPageContent: '',
		primaryDocumentUploadEnabled: false,
		coborrowerDocumentUploadEnabled: false,
		productTypes: [],
		productTypeEnum: {},
		propertyTypes: [],
		propertyTypeEnum: {},
		propertyStatuses: [],
		propertyStatusEnum: {},
		ethnicGroups: [],
		genders: [],
		races: [],
		phoneTypes: [],
		additionalResidentialHistoryThresholdInMonths: 0,
		additionalEmploymentHistoryThresholdInMonths: 0,
		showSlideShowAtSubmit: false,
		inputConfigs: [],
		displayCitizenshipStatusField: false,
		displayRecentGraduateField: false,
		displayMaritalStatusField: false,
		residenceStatuses: [],
		performPersonVerification: false,
		displayPhoneTypeField: false,
		coApplicantModalTitle: '',
		coApplicantModalContent: '',
		displayPreferredContactMethodField: false,
		preferredContactMethods: [],
		paymentProtectionProductConfigs: [],
		requireFormOfIdentificationEntry: false,
		autoPopulateCountyByPostalCode: false,
		coApplicantIdentificationIsRequired: false,
		allowCoApplicantFormOfIdentificationEntry: false,
		includeEmploymentForReview: false,
		taxpayerIdentificationNumberConfigurations: [],
		cachedIdentificationApplicantType: null,
		addressVendorToken: '',
		enablePrimaryAddressAutoComplete: false,
		enableMailingAddressAutoComplete: false,
		enableHELOCAddressAutoComplete: false,
		enableReviewModalAddressAutoComplete: false,
		enablePreviousAddressAutoComplete: false,
		docVSdkKey: '',
		docVMobileView: false,
		docVCameralessOption: false,
		docVUseQrCode: false,
		incomeEntryTypes: [],
		simplifiedLoanOfferPageCardText: '',
		simplifiedLoanOfferPageDynamicHtml: '',
		productIneligiblePageCardText: '',
		productIneligiblePageDynamicHtml: '',
		useVehicleOptions: false,
		enableAutoCompleteForAddressLineTwo: false,
		gliaToggle: false,
		loanPurposeQuestionHeader: '',
		includeBusinessPurposeOnLoanPurposeQuestion: false,
		showPrimaryAddressCheckbox: false,
		showLiensAndJudgementsCheckbox: false,
		showHeldInTrustCheckbox: false,
		requiredAddressHistoryNoteLabel: '',
		optionalAddressHistoryNoteLabel: '',
		showAdditionalAddressHistoryCheckbox: false,
		requiredEmploymentHistoryNoteLabel: '',
		optionalEmploymentHistoryNoteLabel: '',
		showAdditionalEmploymentHistoryCheckbox: false,
		specialIncomeConfidentialityNoteLabel: '',
		showAdditionalIncomeSourceRadioButton: false,
		productIneligiblePageCardText: '',
		productIneligiblePageSubText: '',
		formMessages: [],
		showSmsOptInForManual: false,
		showSmsOptInForAuthenticated: false,
		heroTextConfigurations: []
	},
	mutations: {
		setData(state, { objName, data }) {
			state[objName] = data;
		},
		resetState(state) {
			state.states = [];
			state.residenceHistoryRequiredInMonths = 0;
			state.disclosures = [];
			state.disclosureId = 0;
			state.eligibilityCounties = [];
			state.eligibilityOptions = [];
			//state.occupations = [];
			state.employmentHistoryRequiredInMonths = 0;
			state.employmentStatuses = [];
			state.citizenshipStatuses = [];
			state.maritalStatuses = [];
			state.identificationTypes = [];
			state.countries = [];
			state.acceptedCountryCodes = [];
			state.incomeSources = [];
			state.declinePageContent = '';
			state.declineCardText = '';
			state.reviewPageContent = '';
			state.primaryDocumentUploadEnabled = false;
			state.coborrowerDocumentUploadEnabled = false;
			state.productTypes = [];
			state.productTypeEnum = {};
			state.propertyTypes = [];
			state.propertyTypeEnum = {};
			state.propertyStatuses = [];
			state.propertyStatusEnum = {};
			state.ethnicGroups = [];
			state.genders = [];
			state.races = [];
			state.phoneTypes = [];
			state.additionalResidentialHistoryThresholdInMonths = 0;
			state.additionalEmploymentHistoryThresholdInMonths = 0;
			state.showSlideShowAtSubmit = false;
			state.residenceStatuses = [];
			state.performPersonVerification = false;
			state.displayPhoneTypeField = false;
			state.coApplicantModalTitle = '';
			state.coApplicantModalContent = '';
			state.displayPreferredContactMethodField = false;
			state.preferredContactMethods = [];
			state.paymentProtectionProductConfigs = [];
			state.cachedIdentificationApplicantType = null;
			state.requireFormOfIdentificationEntry = false;
			state.autoPopulateCountyByPostalCode = false;
			state.includeEmploymentForReview = false;
			state.taxpayerIdentificationNumberConfigurations = false;
			state.addressVendorToken = '';
			state.enablePrimaryAddressAutoComplete = false;
			state.enableMailingAddressAutoComplete = false;
			state.enableHELOCAddressAutoComplete = false;
			state.enableReviewModalAddressAutoComplete = false;
			state.enablePreviousAddressAutoComplete = false;
			state.incomeEntryTypes = [];
			state.simplifiedLoanOfferPageCardText = '';
			state.simplifiedLoanOfferPageDynamicHtml = '';
			state.productIneligiblePageCardText = '';
			state.productIneligiblePageDynamicHtml = '';
			state.useVehicleOptions = false;
			state.enableAutoCompleteForAddressLineTwo = false;
			state.loanPurposeQuestionHeader = '';
			state.includeBusinessPurposeOnLoanPurposeQuestion = false;
			state.showHeldInTrustCheckbox = false;
			state.showLiensAndJudgementsCheckbox = false;
			state.showPrimaryAddressCheckbox = false;
			state.requiredAddressHistoryNoteLabel = '';
			state.optionalAddressHistoryNoteLabel = '';
			state.showAdditionalAddressHistoryCheckbox = false;
			state.requiredEmploymentHistoryNoteLabel = '';
			state.optionalEmploymentHistoryNoteLabel = '';
			state.showAdditionalEmploymentHistoryCheckbox = false;
			state.specialIncomeConfidentialityNoteLabel = '';
			state.showAdditionalIncomeSourceRadioButton = false;
			state.productIneligiblePageCardText = '';
			state.productIneligiblePageSubText = '';
			state.formMessages = [];
			state.showSmsOptInForManual = false;
			state.showSmsOptInForAuthenticated = false;
		}
	},
	actions: {
		async getAddressConfig({ commit, state }) {
			if (
				state.states.length &&
				state.requiredAddressMonths &&
				state.additionalAddressThreshold &&
				state.residenceStatuses.length
			) {
				return {
					states: state.states,
					residenceHistoryRequiredInMonths: state.residenceHistoryRequiredInMonths,
					additionalResidentialHistoryThresholdInMonths: state.additionalResidentialHistoryThresholdInMonths,
					residenceStatuses: state.residenceStatuses,
					enablePrimaryAddressAutoComplete: state.enablePrimaryAddressAutoComplete,
					enableMailingAddressAutoComplete: state.enableMailingAddressAutoComplete,
					enableHELOCAddressAutoComplete: state.enableHELOCAddressAutoComplete,
					enableReviewModalAddressAutoComplete: state.enableReviewModalAddressAutoComplete,
					enablePreviousAddressAutoComplete: state.enablePreviousAddressAutoComplete,
					enableAutoCompleteForAddressLineTwo: state.enableAutoCompleteForAddressLineTwo,
					requiredAddressHistoryNoteLabel: state.requiredAddressHistoryNoteLabel,
					optionalAddressHistoryNoteLabel: state.optionalAddressHistoryNoteLabel,
					showAdditionalAddressHistoryCheckbox: state.showAdditionalAddressHistoryCheckbox,
				};
			}

			try {
				const {
					states,
					residenceHistoryRequiredInMonths,
					additionalResidentialHistoryThresholdInMonths,
					residenceStatuses,
					enablePrimaryAddressAutoComplete,
					enableMailingAddressAutoComplete,
					enableHELOCAddressAutoComplete,
					enableReviewModalAddressAutoComplete,
					enablePreviousAddressAutoComplete,
					enableAutoCompleteForAddressLineTwo,
					requiredAddressHistoryNoteLabel,
					optionalAddressHistoryNoteLabel,
					showAdditionalAddressHistoryCheckbox,
				} = await addressAPI.getConfig();

				commit('setData', { objName: 'states', data: states });
				commit('setData', {
					objName: 'residenceHistoryRequiredInMonths',
					data: residenceHistoryRequiredInMonths
				});
				commit('setData', {
					objName: 'additionalResidentialHistoryThresholdInMonths',
					data: additionalResidentialHistoryThresholdInMonths
				});
				commit('setData', {
					objName: 'residenceStatuses',
					data: residenceStatuses
				});
				commit('setData', {
					objName: 'enablePrimaryAddressAutoComplete',
					data: enablePrimaryAddressAutoComplete
				});
				commit('setData', {
					objName: 'enableMailingAddressAutoComplete',
					data: enableMailingAddressAutoComplete
				});
				commit('setData', {
					objName: 'enableHELOCAddressAutoComplete',
					data: enableHELOCAddressAutoComplete
				});
				commit('setData', {
					objName: 'enableReviewModalAddressAutoComplete',
					data: enableReviewModalAddressAutoComplete
				});
				commit('setData', {
					objName: 'enablePreviousAddressAutoComplete',
					data: enablePreviousAddressAutoComplete
				});
				commit('setData', {
					objName: 'enableAutoCompleteForAddressLineTwo',
					data: enableAutoCompleteForAddressLineTwo
				});
				commit('setData', {
					objName: 'requiredAddressHistoryNoteLabel',
					data: requiredAddressHistoryNoteLabel
				});
				commit('setData', {
					objName: 'optionalAddressHistoryNoteLabel',
					data: optionalAddressHistoryNoteLabel
				});
				commit('setData', {
					objName: 'showAdditionalAddressHistoryCheckbox',
					data: showAdditionalAddressHistoryCheckbox
				});

				return {
					states,
					residenceHistoryRequiredInMonths,
					additionalResidentialHistoryThresholdInMonths,
					residenceStatuses,
					enablePrimaryAddressAutoComplete,
					enableMailingAddressAutoComplete,
					enableHELOCAddressAutoComplete,
					enableReviewModalAddressAutoComplete,
					enablePreviousAddressAutoComplete,
					enableAutoCompleteForAddressLineTwo,
					requiredAddressHistoryNoteLabel,
					optionalAddressHistoryNoteLabel,
					showAdditionalAddressHistoryCheckbox
				};
			} catch (error) {
				throw error;
			}
		},
		async getAddressVendorToken({ commit, state }) {
			if (state.addressVendorToken.length) {
				return state.addressVendorToken;
			}

			try {
				const token = await addressAPI.getAddressVendorToken();

				commit('setData', { objName: 'addressVendorToken', data: token });

				return token;
			} catch (error) {
				throw error;
			}
		},
		async getPropertyAddressConfig({ commit, state }) {
			try {
				const { autoPopulateCountyByPostalCode, showHeldInTrustCheckbox, showLiensAndJudgementsCheckbox, showPrimaryAddressCheckbox } = await addressAPI.getPropertyAddressConfig();

				commit('setData', { objName: 'autoPopulateCountyByPostalCode', data: autoPopulateCountyByPostalCode });
				commit('setData', { objName: 'showHeldInTrustCheckbox', data: showHeldInTrustCheckbox });
				commit('setData', { objName: 'showLiensAndJudgementsCheckbox', data: showLiensAndJudgementsCheckbox });
				commit('setData', { objName: 'showPrimaryAddressCheckbox', data: showPrimaryAddressCheckbox });

				return {
					autoPopulateCountyByPostalCode,
					showHeldInTrustCheckbox,
					showLiensAndJudgementsCheckbox,
					showPrimaryAddressCheckbox
				};
			} catch (error) {
				throw error;
			}
		},
		async getDisclosuresConfig({ commit, rootState, state }, disclosureId) {
			//welcome letter is unique to each applicant so caching the value may screw things up if they run two applications in a single browser session

			try {
				const { disclosures, showSlideShowAtSubmit, submitButtonLabel, submitWarningText } =
					await disclosuresAPI.getConfig({
						loanTypeId: disclosureId,
						applicationId: rootState.application.applicationId
					});

				commit('setData', { objName: 'disclosureId', data: disclosureId });
				commit('setData', { objName: 'disclosures', data: disclosures });
				commit('setData', { objName: 'showSlideShowAtSubmit', data: showSlideShowAtSubmit });
				commit('setData', { objName: 'disclosurePageSubmitButtonLabel', data: submitButtonLabel });
				commit('setData', { objName: 'disclosurePageSubmitWarningText', data: submitWarningText });

				return { disclosures, showSlideShowAtSubmit, submitButtonLabel, submitWarningText };
			} catch (error) {
				throw error;
			}
		},
		async getInputConfig({ commit, rootState, state }) {
			try {
				const { inputConfigurations } = await formInputAPI.getConfig();

				commit('setData', { objName: 'inputConfigs', data: inputConfigurations });

				return { inputConfigurations };
			} catch (error) {
				throw error;
			}
		},
		async getEligibilityConfig({ commit, getters, state }) {
			if (getters.hasEligibility) {
				return { counties: state.eligibilityCounties, options: state.eligibilityOptions };
			}

			try {
				const {
					counties,
					options,
					ineligiblePageText,
					eligibilityPageHeader,
					eligibilityPageSuboptionLabel,
					ineligiblePageCardText
				} = await eligibilityAPI.getConfig();

				commit('setData', { objName: 'eligibilityCounties', data: counties });
				commit('setData', { objName: 'eligibilityOptions', data: options });
				commit('setData', { objName: 'ineligiblePageText', data: ineligiblePageText });
				commit('setData', { objName: 'eligibilityPageHeader', data: eligibilityPageHeader });
				commit('setData', { objName: 'eligibilityPageSuboptionLabel', data: eligibilityPageSuboptionLabel });
				commit('setData', { objName: 'ineligiblePageCardText', data: ineligiblePageCardText });

				return {
					counties,
					options,
					ineligiblePageText,
					eligibilityPageHeader,
					eligibilityPageSuboptionLabel,
					ineligiblePageCardText
				};
			} catch (error) {
				throw new Error(error);
			}
		},
		async getEmploymentConfig({ commit, state }) {
			if (
				state.incomeSources.length &&
				state.employmentStatuses.length &&
				state.occupations.length &&
				state.employmentHistoryRequiredInMonths &&
				state.additionalEmploymentHistoryThresholdInMonths &&
				state.incomeEntryTypes
			) {
				return {
					incomeSources: state.incomeSources,
					employmentStatuses: state.employmentStatuses,
					occupations: state.occupations,
					requiredMonths: state.employmentHistoryRequiredInMonths,
					additionalEmploymentHistoryThresholdInMonths: state.additionalEmploymentHistoryThresholdInMonths,
					incomeEntryTypes: state.incomeEntryTypes,
					requiredEmploymentHistoryNoteLabel: state.requiredEmploymentHistoryNoteLabel,
					optionalEmploymentHistoryNoteLabel: state.optionalEmploymentHistoryNoteLabel,
					showAdditionalEmploymentHistoryCheckbox: state.showAdditionalEmploymentHistoryCheckbox,
					specialIncomeConfidentialityNoteLabel: state.specialIncomeConfidentialityNoteLabel,
					showAdditionalIncomeSourceRadioButton: state.showAdditionalIncomeSourceRadioButton,
				};
			}

			try {
				const {
					incomeSources,
					employmentStatuses,
					occupations,
					employmentHistoryRequiredInMonths,
					additionalEmploymentHistoryThresholdInMonths,
					incomeEntryTypes,
					requiredEmploymentHistoryNoteLabel,
					optionalEmploymentHistoryNoteLabel,
					showAdditionalEmploymentHistoryCheckbox,
					specialIncomeConfidentialityNoteLabel,
					showAdditionalIncomeSourceRadioButton
				} = await employmentAPI.getConfig();

				commit('setData', { objName: 'incomeSources', data: incomeSources });
				commit('setData', { objName: 'employmentStatuses', data: employmentStatuses });
				commit('setData', { objName: 'occupations', data: occupations });
				commit('setData', {
					objName: 'employmentHistoryRequiredInMonths',
					data: employmentHistoryRequiredInMonths
				});
				commit('setData', {
					objName: 'additionalEmploymentHistoryThresholdInMonths',
					data: additionalEmploymentHistoryThresholdInMonths
				});
				commit('setData', {
					objName: 'incomeEntryTypes',
					data: incomeEntryTypes
				});
				commit('setData', {
					objName: 'requiredEmploymentHistoryNoteLabel',
					data: requiredEmploymentHistoryNoteLabel
				});
				commit('setData', {
					objName: 'optionalEmploymentHistoryNoteLabel',
					data: optionalEmploymentHistoryNoteLabel
				});
				commit('setData', {
					objName: 'showAdditionalEmploymentHistoryCheckbox',
					data: showAdditionalEmploymentHistoryCheckbox
				});
				commit('setData', {
					objName: 'specialIncomeConfidentialityNoteLabel',
					data: specialIncomeConfidentialityNoteLabel
				});
				commit('setData', {
					objName: 'showAdditionalIncomeSourceRadioButton',
					data: showAdditionalIncomeSourceRadioButton
				});

				return {
					incomeSources,
					employmentStatuses,
					occupations,
					employmentHistoryRequiredInMonths,
					additionalEmploymentHistoryThresholdInMonths,
					incomeEntryTypes,
					requiredEmploymentHistoryNoteLabel,
					optionalEmploymentHistoryNoteLabel,
					showAdditionalEmploymentHistoryCheckbox,
					specialIncomeConfidentialityNoteLabel,
					showAdditionalIncomeSourceRadioButton
				};
			} catch (error) {
				throw error;
			}
		},
		async getMaxMonthlyIncome({ commit, state }) {
			if (state.maxMonthlyIncome) {
				return state.maxMonthlyIncome;
			}

			try {
				const { maxMonthlyIncome } = await incomeAPI.getMaxMonthlyIncome();

				commit('setData', { objName: 'maxMonthlyIncome', data: maxMonthlyIncome });

				return maxMonthlyIncome;
			} catch (error) {
				throw error;
			}
		},
		async getIdentificationConfig({ commit, state }, applicantType) {
			// Check if we have cached data for this specific applicant type
			if (
				state.cachedIdentificationApplicantType === applicantType &&
				state.citizenshipStatuses.length &&
				state.maritalStatuses.length &&
				state.identificationTypes.length &&
				state.phoneTypes.length &&
				state.preferredContactMethods.length &&
				typeof state.displayMaritalStatusField !== 'undefined' &&
				typeof state.displayCitizenshipStatusField != 'undefined' &&
				typeof state.displayRecentGraduateField != 'undefined' &&
				typeof state.displayPhoneTypeField != 'undefined' &&
				typeof state.displayPreferredContactMethodField != 'undefined' &&
				state.recentGraduateLink &&
				typeof state.displayFirstTimeAutoBuyerField != 'undefined' &&
				state.firstTimeAutoBuyerFieldLabel &&
				typeof state.requireFormOfIdentificationEntry !== 'undefined' &&
				typeof state.taxpayerIdentificationNumberConfigurations !== 'undefined' &&
				state.countries.length &&
				typeof state.acceptedCountryCodes !== 'undefined' &&
				typeof state.forceMobilePhone !== 'undefined' &&
				typeof state.enableDatePickerDesktop !== 'undefined' &&
				typeof state.enableDatePickerMobile !== 'undefined'
			) {
				return {
					citizenshipStatuses: state.citizenshipStatuses,
					maritalStatuses: state.maritalStatuses,
					identificationTypes: state.identificationTypes,
					phoneTypes: state.phoneTypes,
					preferredContactMethods: state.preferredContactMethods,
					displayMaritalStatusField: state.displayMaritalStatusField,
					displayCitizenshipStatusField: state.displayCitizenshipStatusField,
					displayRecentGraduateField: state.displayRecentGraduateField,
					displayPhoneTypeField: state.displayPhoneTypeField,
					displayPreferredContactMethodField: state.displayPreferredContactMethodField,
					recentGraduateLink: state.recentGraduateLink,
					displayFirstTimeAutoBuyerField: state.displayFirstTimeAutoBuyerField,
					firstTimeAutoBuyerFieldLabel: state.firstTimeAutoBuyerFieldLabel,
					requireFormOfIdentificationEntry: state.requireFormOfIdentificationEntry,
					taxpayerIdentificationNumberConfigurations: state.taxpayerIdentificationNumberConfigurations,
					countries: state.countries,
					acceptedCountryCodes: state.acceptedCountryCodes,
					forceMobilePhone: state.forceMobilePhone,
					enableDatePickerDesktop: state.enableDatePickerDesktop,
					enableDatePickerMobile: state.enableDatePickerMobile
				};
			}

			try {
				const {
					citizenshipStatuses,
					maritalStatuses,
					identificationTypes,
					phoneTypes,
					preferredContactMethods,
					displayMaritalStatusField,
					displayCitizenshipStatusField,
					displayRecentGraduateField,
					displayPhoneTypeField,
					displayPreferredContactMethodField,
					recentGraduateLink,
					displayFirstTimeAutoBuyerField,
					firstTimeAutoBuyerFieldLabel,
					requireFormOfIdentificationEntry,
					taxpayerIdentificationNumberConfigurations,
					countries,
					acceptedCountryCodes,
					forceMobilePhone,
					enableDatePickerDesktop,
					enableDatePickerMobile
				} = await identificationAPI.getConfig(applicantType);

				// Store which applicant type this cached data belongs to
				commit('setData', { objName: 'cachedIdentificationApplicantType', data: applicantType });

				commit('setData', { objName: 'citizenshipStatuses', data: citizenshipStatuses });
				commit('setData', { objName: 'maritalStatuses', data: maritalStatuses });
				commit('setData', { objName: 'identificationTypes', data: identificationTypes });
				commit('setData', { objName: 'phoneTypes', data: phoneTypes });
				commit('setData', { objName: 'preferredContactMethods', data: preferredContactMethods });
				commit('setData', { objName: 'displayMaritalStatusField', data: displayMaritalStatusField });
				commit('setData', { objName: 'displayCitizenshipStatusField', data: displayCitizenshipStatusField });
				commit('setData', { objName: 'displayRecentGraduateField', data: displayRecentGraduateField });
				commit('setData', { objName: 'displayPhoneTypeField', data: displayPhoneTypeField });
				commit('setData', {
					objName: 'displayPreferredContactMethodField',
					data: displayPreferredContactMethodField
				});
				commit('setData', { objName: 'recentGraduateLink', data: recentGraduateLink });
				commit('setData', { objName: 'displayFirstTimeAutoBuyerField', data: displayFirstTimeAutoBuyerField });
				commit('setData', { objName: 'firstTimeAutoBuyerFieldLabel', data: firstTimeAutoBuyerFieldLabel });
				commit('setData', {
					objName: 'requireFormOfIdentificationEntry',
					data: requireFormOfIdentificationEntry
				});
				commit('setData', {
					objName: 'taxpayerIdentificationNumberConfigurations',
					data: taxpayerIdentificationNumberConfigurations
				});
				commit('setData', {
					objName: 'forceMobilePhone',
					data: forceMobilePhone
				});
				commit('setData', {
					objName: 'enableDatePickerDesktop',
					data: enableDatePickerDesktop
				});

				commit('setData', {
					objName: 'enableDatePickerMobile',
					data: enableDatePickerMobile
				});

				commit('setData', { objName: 'countries', data: countries.filter(config => config.countryCode) });

				commit('setData', { objName: 'acceptedCountryCodes', data: acceptedCountryCodes });

				return {
					citizenshipStatuses,
					maritalStatuses,
					identificationTypes,
					phoneTypes,
					preferredContactMethods,
					displayMaritalStatusField,
					displayCitizenshipStatusField,
					displayRecentGraduateField,
					displayPhoneTypeField,
					displayPreferredContactMethodField,
					recentGraduateLink,
					displayFirstTimeAutoBuyerField,
					firstTimeAutoBuyerFieldLabel,
					requireFormOfIdentificationEntry,
					taxpayerIdentificationNumberConfigurations,
					countries: state.countries,
					acceptedCountryCodes,
					forceMobilePhone,
					enableDatePickerDesktop,
					enableDatePickerMobile
				};
			} catch (error) {
				throw error;
			}
		},
		async getCoApplicantConfig({ commit, state }) {
			try {
				const { allowCoApplicantFormOfIdentificationEntry, coApplicantIdentificationIsRequired, compareCoApplicantSsnToPrimaryEnabled } =
					await coApplicantAPI.getConfig();

				commit('setData', {
					objName: 'requireCoApplicantFormOfIdentificationEntry',
					data: allowCoApplicantFormOfIdentificationEntry
				});

				return {
					allowCoApplicantFormOfIdentificationEntry,
					coApplicantIdentificationIsRequired,
					compareCoApplicantSsnToPrimaryEnabled
				};
			} catch (error) {
				throw error;
			}
		},
		async getIncomeConfig({ commit, state }) {
			if (state.incomeSources.length) {
				return { incomeSources: state.incomeSources };
			}

			try {
				const { incomeSources } = await incomeAPI.getConfig();

				commit('setData', { objName: 'incomeSources', data: incomeSources });

				return { incomeSources };
			} catch (error) {
				throw error;
			}
		},
		async getDeclineConfig({ commit, state }) {
			if (state.declinePageContent && state.declineCardText) {
				return { content: state.declinePageContent, cardText: state.declineCardText };
			}

			try {
				const { content, cardText } = await errorAPI.getDeclineConfig();

				commit('setData', { objName: 'declinePageContent', data: content });
				commit('setData', { objName: 'declineCardText', data: cardText });

				return { content, cardText };
			} catch (error) {
				throw error;
			}
		},
		async getReviewConfig({ commit, getters, rootState, state, dispatch }) {
			try {
				var productTypeId = await dispatch('application/getProductTypeId', null, { root: true });

				const { content, primaryDocumentUploadEnabled, coborrowerDocumentUploadEnabled } =
					await errorAPI.getReviewConfig(productTypeId);

				commit('setData', { objName: 'reviewPageContent', data: content });
				commit('setData', { objName: 'primaryDocumentUploadEnabled', data: primaryDocumentUploadEnabled });
				commit('setData', {
					objName: 'coborrowerDocumentUploadEnabled',
					data: coborrowerDocumentUploadEnabled
				});

				return { content, primaryDocumentUploadEnabled, coborrowerDocumentUploadEnabled };
			} catch (error) {
				throw error;
			}
		},
		async getDocumentUploadConfig({ commit, state }) {
			if (state.documentUploadConfiguration) {
				return {
					documentUploadConfiguration: state.documentUpload
				};
			}

			try {
				const { documentUploadConfiguration } = await documentAPI.getDocumentUploadConfig();

				commit('setData', { objName: 'documentUploadConfig', data: documentUploadConfiguration });

				return { documentUploadConfiguration };
			} catch (error) {
				throw error;
			}
		},
		async getProductTypes({ commit, state }) {
			if (state.productTypes.length && state.productTypeEnum && Object.keys(state.productTypeEnum).length) {
				return { list: state.productTypes, enumObj: state.productTypeEnum };
			}

			try {
				const {
					data: { products }
				} = await axios.get(`${process.env.BASE_URL}api/SelectProduct/Configuration`);

				const productTypes = products.map(({ displayText, id, routePrefix }) => ({
					value: id,
					label: displayText,
					routePrefix
				}));

				const productTypeEnum = {};

				for (const object of products) {
					productTypeEnum[object.id] = object.routePrefix;
					productTypeEnum[object.routePrefix.replace(/ /g, '_').toUpperCase()] = object.id;
				}

				commit('setData', { objName: 'productTypes', data: productTypes });
				commit('setData', { objName: 'productTypeEnum', data: productTypeEnum });

				return { list: productTypes, enumObj: productTypeEnum };
			} catch (error) {
				throw error;
			}
		},
		async getPropertyTypes({ commit, state }) {
			if (state.propertyTypes.length && state.propertyTypeEnum && Object.keys(state.propertyTypeEnum).length) {
				return { list: state.propertyTypes, enumObj: state.propertyTypeEnum };
			}

			try {
				const {
					data: { propertyTypes }
				} = await axios.get(`${process.env.BASE_URL}api/PropertyType/Configuration`);

				const propertyTypesList = getListValueFromConfigObject(propertyTypes);
				const propertyTypeEnum = getEnumFromConfigObject(propertyTypes);

				commit('setData', { objName: 'propertyTypes', data: propertyTypesList });
				commit('setData', { objName: 'propertyTypeEnum', data: propertyTypeEnum });

				return { list: propertyTypesList, enumObj: propertyTypeEnum };
			} catch (error) {
				throw error;
			}
		},
		async getPropertyStatuses({ commit, state }) {
			if (
				state.propertyStatuses.length &&
				state.propertyStatusEnum &&
				Object.keys(state.propertyStatusEnum).length
			) {
				return { list: state.propertyStatuses, enumObj: state.propertyStatusEnum };
			}

			try {
				const {
					data: { propertyStatuses }
				} = await axios.get(`${process.env.BASE_URL}api/PropertyStatus/Configuration`);

				let displayedPropertyStatuses = propertyStatuses.filter(x => x.displayed);

				const propertyStatusesList = displayedPropertyStatuses.map(({ displayText, id, requiresManualEntry, parentConfigId, populateAsCurrentAddress }) => ({
					value: id,
					label: displayText,
					requiresManualEntry,
					parentConfigId: parentConfigId,
					populateAsCurrentAddress: populateAsCurrentAddress
				}));

				const propertyStatusEnum = getEnumFromConfigObject(propertyStatuses);

				commit('setData', { objName: 'propertyStatuses', data: propertyStatusesList });
				commit('setData', { objName: 'propertyStatusEnum', data: propertyStatusEnum });

				return { list: propertyStatusesList, enumObj: propertyStatusEnum };
			} catch (error) {
				throw error;
			}
		},
		async getDemographicConfig({ commit, state }) {
			if (state.ethnicGroups.length && state.genders.length && state.races.length) {
				return { ethnicGroups: state.ethnicGroups, genders: state.genders, races: state.races };
			}

			try {
				const { ethnicGroups, genders, races } = await demographicAPI.getConfig();

				commit('setData', { objName: 'ethnicGroups', data: ethnicGroups });
				commit('setData', { objName: 'genders', data: genders });
				commit('setData', { objName: 'races', data: races });

				return { ethnicGroups, genders, races };
			} catch (error) {
				throw new Error(error);
			}
		},
		async getCoApplicantModalConfig({ commit, state }) {
			if (state.coApplicantModalTitle.length && state.coApplicantModalContent.length) {
				return {
					coApplicantModalTitle: state.coApplicantModalTitle,
					coApplicantModalContent: state.coApplicantModalContent
				};
			}

			try {
				const { coApplicantModalTitle, coApplicantModalContent } = await coApplicantAPI.getModalConfig();

				commit('setData', { objName: 'coApplicantModalTitle', data: coApplicantModalTitle });
				commit('setData', { objName: 'coApplicantModalContent', data: coApplicantModalContent });

				return { coApplicantModalTitle, coApplicantModalContent };
			} catch (error) {
				throw new Error(error);
			}
		},
		async getPaymentProtectionProductConfigurations({ commit, rootState, state }) {
			try {
				const { productConfigurations } =
					await paymentProtectionAPI.getConfig({
						applicationId: rootState.application.applicationId
					});

				commit('setData', { objName: 'paymentProtectionProductConfigs', data: productConfigurations });

				return { paymentProtectionProductConfigs: productConfigurations };
			} catch (error) {
				throw error;
			}
		},
		async getReviewPageConfig({ commit, state }) {
			try {
				const { includeEmploymentForReview, disableVehicleEditing } = await reviewAPI.getConfig();

				commit('setData', { objName: 'includeEmploymentForReview', data: includeEmploymentForReview });
				commit('setData', { objName: 'disableVehicleEditing', data: disableVehicleEditing });

				return {
					includeEmploymentForReview,
					disableVehicleEditing
				};
			} catch (error) {
				throw error;
			}
		},
		async getDocumentVerificationPageConfig({ commit, state }) {
			try {
				let viewportWidth = window.screen.width;
				const { docVSdkKey, mobileView, noCameraOptionDisplay, useQrCode, showSlideShowAtSubmit } =
					await documentVerificationAPI.getConfig(viewportWidth);

				commit('setData', { objName: 'docVSdkKey', data: docVSdkKey });
				commit('setData', { objName: 'docVMobileView', data: mobileView });
				commit('setData', { objName: 'docVCameralessOption', data: noCameraOptionDisplay });
				commit('setData', { objName: 'docVUseQrCode', data: useQrCode });
				commit('setData', { objName: 'showSlideShowAtSubmit', data: showSlideShowAtSubmit });

				return {
					docVSdkKey,
					mobileView,
					noCameraOptionDisplay,
					useQrCode,
					showSlideShowAtSubmit
				};
			} catch (error) {
				throw error;
			}
		},
		async getAuthenticationPageConfig({ commit, state }) {
			try {
				const { forceMobilePhone, authenticationPageReminderText, showSmsOptInForManual, showSmsOptInForAuthenticated, smsOptInLabel } =
					await configurationAPI.getAuthenticationPageConfiguration();

				commit('setData', { objName: 'forceMobilePhone', data: forceMobilePhone });
				commit('setData', { objName: 'authenticationPageReminderText', data: authenticationPageReminderText });
				commit('setData', { objName: 'showSmsOptInForManual', data: showSmsOptInForManual });
				commit('setData', { objName: 'showSmsOptInForAuthenticated', data: showSmsOptInForAuthenticated });
				commit('setData', { objName: 'smsOptInLabel', data: smsOptInLabel });

				return {
					forceMobilePhone,
					authenticationPageReminderText,
					showSmsOptInForManual,
					showSmsOptInForAuthenticated,
					smsOptInLabel
				};
			} catch (error) {
				throw error;
			}
		},
		async getSimplifiedLoanOfferPageConfig({ commit }) {
			try {
				const { simplifiedLoanOfferPageCardText, simplifiedLoanOfferPageDynamicHtml } =
					await configurationAPI.getSimplifiedLoanOfferPageConfig();

				commit('setData', { objName: 'simplifiedLoanPageCardText', data: simplifiedLoanOfferPageCardText });
				commit('setData', {
					objName: 'simplifiedLoanPageDynamicHtml',
					data: simplifiedLoanOfferPageDynamicHtml
				});

				return {
					simplifiedLoanOfferPageCardText,
					simplifiedLoanOfferPageDynamicHtml
				};
			} catch (error) {
				throw error;
			}
		},
		async getProductIneligiblePageConfig({ commit }) {
			try {
				const { productIneligiblePageCardText, productIneligiblePageDynamicHtml } =
					await configurationAPI.getProductIneligiblePageConfig();

				commit('setData', { objName: 'productIneligiblePageCardText', data: productIneligiblePageCardText });
				commit('setData', {
					objName: 'productIneligiblePageDynamicHtml',
					data: productIneligiblePageDynamicHtml
				});

				return {
					productIneligiblePageCardText,
					productIneligiblePageDynamicHtml
				};
			} catch (error) {
				throw error;
			}
		},
		async getVehicleCollateralPageConfiguration({ commit, state }) {
			try {
				const { useVehicleOptions } = await configurationAPI.getVehicleCollateralPageConfiguration();

				commit('setData', { objName: 'useVehicleOptions', data: useVehicleOptions });

				return {
					useVehicleOptions
				};
			} catch (error) {
				throw error;
			}
		},
		async getFeatureToggleStatus({ commit }, featureToggleId) {
			try {
				const isEnabled = await configurationAPI.getFeatureToggleStatus(featureToggleId);
				return isEnabled;
			} catch (error) {
				console.error(`Error getting feature toggle ${featureToggleId}:`, error);
				// Return false as default if there's an error
				return false;
			}
		},
		async getLoanPurposeQuestionConfigurations({ commit, rootState, state }) {
			if (state.loanPurposeQuestions && state.loanPurposeQuestions.length) {
				return state.loanPurposeQuestions;
			}

			try {
				let loanAppConfigurationId = rootState.application.productTypeId;

				const loanPurposeQuestionConfigurations = await configurationAPI.getLoanPurposeQuestionConfigurations(loanAppConfigurationId);

				commit('setData', { objName: 'loanPurposeQuestions', data: loanPurposeQuestionConfigurations });

				return loanPurposeQuestionConfigurations;
			} catch (error) {
				throw error;
			}
		},
		async getLoanPurposeQuestionPageConfiguration({ commit, rootState, state }) {
			if (state.loanPurposeQuestionHeader && state.loanPurposeQuestionHeader.length) {
				return { 
					loanPurposeQuestionHeader: state.loanPurposeQuestionHeader,
					includeBusinessPurposeOnLoanPurposeQuestion: state.includeBusinessPurposeOnLoanPurposeQuestion
				};
			}

			try {
				const { loanPurposeQuestionHeader, includeBusinessPurposeOnLoanPurposeQuestion } = await configurationAPI.getLoanPurposeQuestionPageConfiguration();

				commit('setData', { objName: 'loanPurposeQuestionHeader', data: loanPurposeQuestionHeader });
				commit('setData', { objName: 'includeBusinessPurposeOnLoanPurposeQuestion', data: includeBusinessPurposeOnLoanPurposeQuestion });

				return { loanPurposeQuestionHeader, includeBusinessPurposeOnLoanPurposeQuestion };
			} catch (error) {
				throw error;
			}
		},
		async getIneligiblePageErrorData({ commit, getters, state }, applicationToken) {
			if (state.ineligiblePageText, state.ineligiblePageCardText) {
				return { ineligiblePageText: state.ineligiblePageText, ineligiblePageCardText: state.ineligiblePageCardText };
			}

			try {
				const {
					ineligiblePageText,
					ineligiblePageCardText
				} = await errorAPI.getIneligiblePageError(applicationToken);

				commit('setData', { objName: 'ineligiblePageText', data: ineligiblePageText });
				commit('setData', { objName: 'ineligiblePageCardText', data: ineligiblePageCardText });

				return {
					ineligiblePageText,
					ineligiblePageCardText
				};
			} catch (error) {
				throw new Error(error);
			}
		},
		async getProductIneligiblePageDiction({ commit, getters, state }, applicationToken) {
			if (state.productIneligiblePageSubText.length && state.productIneligiblePageCardText.length) {
				return { productIneligiblePageSubText: state.productIneligiblePageSubText, productIneligiblePageCardText: state.productIneligiblePageCardText };
			}

			try {
				const {
					productIneligiblePageSubText,
					productIneligiblePageCardText
				} = await errorAPI.getProductIneligiblePageDiction(applicationToken);

				commit('setData', { objName: 'productIneligiblePageSubText', data: productIneligiblePageSubText });
				commit('setData', { objName: 'productIneligiblePageCardText', data: productIneligiblePageCardText });

				return {
					productIneligiblePageSubText,
					productIneligiblePageCardText
				};
			} catch (error) {
				throw error;
			}
		},
		async getCoborrowerSelectPageConfig({ commit, getters, state }, applicationToken) {

			try {

				const { showSmsOptIn, smsOptInLabel, preselectOptIn } =
					await coApplicantAPI.getCoborrowerSelectPageConfig(applicationToken);

				return {
					showSmsOptIn,
					smsOptInLabel,
					preselectOptIn
				};

			} catch (error) {
				throw error;
			}
		},
		async getSmsOptInPageConfig({ commit, getters, state }, applicationToken) {

			try {

				const { smsOptInLabel, preselectOptIn } =
					await applicantAPI.getSmsOptInPageConfig(applicationToken);

				return {
					smsOptInLabel,
					preselectOptIn
				};

			} catch (error) {
				throw error;
			}
		},
		async getHeroTextConfigurations({ commit, state }) {
			if (state.heroTextConfigurations && state.heroTextConfigurations.length > 0) {
				return state.heroTextConfigurations;
			}

			try {
				const heroTextConfigurations = await configurationAPI.getHeroConversationalTextConfigurations();
				
				commit('setData', { objName: 'heroTextConfigurations', data: heroTextConfigurations});

				return heroTextConfigurations || [];
			} catch (error) {
				throw error;
			}
		}
	},
	getters: {
		hasEligibility: state => {
			const hasExistingOptions = Object.keys(state.eligibilityOptions).length !== 0;

			return hasExistingOptions && state.eligibilityCounties ? true : false;
		},
		getInputConfig: state => typeId => {
			return state.inputConfigs.find(x => x.formInputType == typeId);
		},
		getIneligiblePageText: state => state.ineligiblePageText,
		getEligibilityPageHeader: state => state.eligibilityPageHeader,
		getEligibilityPageSuboptionLabel: state => state.eligibilityPageSuboptionLabel,
		getIneligiblePageCardText: state => state.ineligiblePageCardText,
		loanPurposeQuestionHeader: state => state.loanPurposeQuestionHeader,
		getHeroTextForPage: (state, getters, rootState) => (pageIdentifier) => {
			if (!state.heroTextConfigurations || state.heroTextConfigurations.length === 0) {
				return { desktopHeroText: null, mobileHeroText: null };
			}

			const productTypeId = rootState.application.productTypeId == 0 ? null : rootState.application.productTypeId; // Treat productTypeId of 0 as null for configuration matching

			const productSpecific = state.heroTextConfigurations.find(
				config => config.pageIdentifier === pageIdentifier && 
						 config.loanTypeId === productTypeId
			);

			if (productSpecific) {
				return {
					desktopHeroText: productSpecific.desktopHeroText,
					mobileHeroText: productSpecific.mobileHeroText
				};
			}

			// No configuration found
			return { desktopHeroText: null, mobileHeroText: null };
		}
	}
};
